import { useRef } from "react";

export function useLongPress(callback = () => {}, ms = 500, threshold = 10) {
  const timerRef = useRef();
  const isLongPressActive = useRef(false);
  const startPosRef = useRef({ x: 0, y: 0 });

  const start = (e) => {
    isLongPressActive.current = false;
    if (e.type === "touchstart") {
      const touch = e.touches[0];
      startPosRef.current = { x: touch.clientX, y: touch.clientY };
    }
    timerRef.current = setTimeout(() => {
      isLongPressActive.current = true;
      callback(e);
    }, ms);
  };

  const clear = (e) => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }

    if (e?.type === "touchend") {
      const touch = e.changedTouches[0];
      const dx = Math.abs(touch.clientX - startPosRef.current.x);
      const dy = Math.abs(touch.clientY - startPosRef.current.y);

      if (dx > threshold || dy > threshold) {
        return;
      }
    }

    const wasLongPress = isLongPressActive.current;

    setTimeout(() => {
      isLongPressActive.current = false;
    }, 100);

    return wasLongPress;
  };

  return {
    onMouseDown: start,
    onTouchStart: start,
    onMouseUp: clear,
    onMouseLeave: clear,
    onTouchEnd: clear,
    wasLongPress: () => isLongPressActive.current,
  };
}
